/** Shared across instant-rips, white-elephant, and async experiences */
export const commonSounds = {
    cardReveal: { src: '/audio/04_CARD_REVEAL.mp3' },
    cardRotate: { src: '/audio/05_CARD_ROTATE.mp3' },
    cardFlip: { src: '/audio/06_CARD_FLIP.mp3' },
    packDisolve: { src: '/audio/02_PACK_DISSOLVE.mp3' },
};
